import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule,
} from "vuex-module-decorators";
import store from "@/store";
import SupervisiAmbulansSvc, {
  SupervisiAmbulansListFilter,
} from "@/services/SupervisiAmbulansService";
import { SupervisiAmbulans } from "@/types/SupervisiAmbulans";

@Module({
  store,
  dynamic: true,
  namespaced: true,
  name: "supervisi-ambulans",
})
class SupervisiAmbulansModule extends VuexModule {
  items: SupervisiAmbulans[] = [];
  currentItem: SupervisiAmbulans | null = null;
  loading = false;
  meta: {
    current_page: number;
    per_page: number;
    total: number;
    last_page: number;
  } | null = null;

  @Mutation SET_ITEMS(val: SupervisiAmbulans[]) {
    this.items = val || [];
  }

  @Mutation SET_CURRENT_ITEM(val: SupervisiAmbulans | null) {
    this.currentItem = val;
  }

  @Mutation SET_META(val: any) {
    this.meta = val || null;
  }

  @Mutation SET_LOADING(val: boolean) {
    this.loading = val;
  }

  @Action async fetchList(params: SupervisiAmbulansListFilter = {}) {
    this.SET_LOADING(true);
    try {
      const dt = await SupervisiAmbulansSvc.list(params);
      this.SET_ITEMS(dt.data.data || []);
      this.SET_META(dt.data.meta || null);
    } catch {
      this.SET_ITEMS([]);
      this.SET_META(null);
    }
    this.SET_LOADING(false);
  }

  @Action async refresh(id: number) {
    this.SET_LOADING(true);
    try {
      const dt = await SupervisiAmbulansSvc.find(id);
      this.SET_CURRENT_ITEM(dt.data.data || null);
    } catch {
      this.SET_CURRENT_ITEM(null);
    }
    this.SET_LOADING(false);
  }

  @Action reset() {
    this.SET_ITEMS([]);
    this.SET_CURRENT_ITEM(null);
    this.SET_META(null);
  }
}

export const storeSupervisiAmbulans = getModule(SupervisiAmbulansModule);
